export default "__VITE_ASSET__RsvsyZ5p__"